<template>
  <div
    class="row py-3 justify-content-end flex-shrink-0 idea-form"
    id="filter-div"
    style="margin-left: 20px; margin-right: 20px; margin-top: 20px"
  >
    <div id="searchContainer" class="col-12 row m-0 p-0">
      <div class="container mb-3 mw-100">
        <div class="form-group col-12 col-md-12 row">
          <div class="col-12 col-md-6 column-flex mb-3">
            <div class="col-md-4">
              <label for="searchProblemText">Fikir Numarası</label>
            </div>
            <div class="col-md-8">
              <input
                type="text"
                class="form-control"
                id="suggestionNumber"
                name="suggestionNumber"
                v-model="suggestionNumber"
              />
            </div>
          </div>

          <div class="col-12 col-md-6 column-flex">
            <div class="col-md-4">
              <label for="searchFilterStatus">Fikir Sahibi</label>
            </div>
            <div class="col-md-8">
              <multiselect
                v-model="createdUserId"
                placeholder="Tümü"
                label="name"
                track-by="code"
                :options="filteredData"
                :searchable="true"
                :multiple="true"
                :max="1"
                :disabled="isIdea == 'my-idea' && isForm != 'projectPool'"
                :loading="isLoadingUsers"
                selectLabel="Seçmek için tıklayınız"
                selectedLabel="Seçildi"
                deselectLabel="Silmek için tıklayınız"
                :internal-search="false"
                @search-change="asyncFind"
              >
                <template slot="noOptions">
                  <span v-if="isLoadingUsers">Yükleniyor...</span>
                  <span v-else>Liste boş.</span>
                </template>
              </multiselect>
            </div>
          </div>
          <div class="col-12 col-md-6 column-flex mb-3">
            <div class="col-md-4">
              <label for="drpAccount">Fikir Verilen Firmalar</label>
            </div>
            <div class="col-md-8">
              <select
                class="form-control"
                id="drpAccount"
                name="AccountId"
                title="Tümü"
                placeholder="Tümü"
                v-model="selectedCompany"
              >
                <option
                  v-for="(item, key) in companiesList"
                  :key="key"
                  :value="item.Id"
                >
                  {{ item.Name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-12 col-md-6 column-flex mb-3">
            <div class="col-md-4">
              <label for="searchProblemText">Anahtar Kelime</label>
            </div>
            <div class="col-md-8">
              <input
                class="form-control"
                id="searchKeywordText"
                name="KeywordText"
                type="text"
                v-model="searchKeyword"
              />
            </div>
          </div>

          <div v-if="isForm == 'idea'" class="col-12 col-md-6 column-flex mb-3">
            <div class="col-md-4">
              <label for="searchFilterValueCurrent">Değer Akımı</label>
            </div>
            <div class="col-md-8">
              <select
                class="form-control"
                id="searchFilterValueCurrent"
                name="ValueCurrent"
                title="Tümü"
                placeholder="Tümü"
                v-model="valueCurrentId"
              >
                <option value="">Tümü</option>
                <optgroup
                  v-for="item in currenValuelist"
                  :key="item.Name"
                  :label="item.Name"
                >
                  <option
                    v-for="company in item.ValueCurrentDTOs"
                    :key="company.Id"
                    :value="company.Id"
                  >
                    {{ company.Name }}
                  </option>
                </optgroup>
              </select>
            </div>
          </div>

          <div class="col-12 col-md-6 column-flex mb-3 mb-3">
            <div class="col-md-4">
              <label for="searchFilterStart">Tarih Aralığı</label>
            </div>

            <div class="col-md-8">
              <div class="d-flex flex-column flex-md-row date-container">
                <div class="col-12 col-md-6 pl-0">
                  <input
                    type="date"
                    class="datepicker form-control"
                    id="searchFilterStart"
                    v-model="startDate"
                  />
                </div>
                <div
                  class="col-12 col-md-6 pl-0 pl-md-2 mt-2 mt-md-0 date-container"
                >
                  <input
                    type="date"
                    class="datepicker form-control"
                    id="searchFilterEnd"
                    v-model="endDate"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 column-flex">
            <div class="col-md-4">
              <label for="searchFilterStatus">Statü Seçiniz</label>
            </div>
            <div class="col-md-8">
              <multiselect
                v-model="suggestionStatuses"
                tag-placeholder="Add this as new tag"
                placeholder="Tümü"
                label="name"
                track-by="code"
                :options="filteredStatusData"
                :multiple="true"
                :taggable="true"
                :searchable="true"
                @tag="addTag"
                selectLabel="Seçmek için tıklayınız"
                selectedLabel="Seçildi"
                deselectLabel="Silmek için tıklayınız"
                :internal-search="false"
                @search-change="asyncFindStatus"                
              ></multiselect>
            </div>
          </div>
          <div
            v-if="isForm == 'projectPool'"
            class="col-12 col-md-6 column-flex"
          >
            <div class="col-md-4">
              <label>Departman</label>
            </div>
            <div class="col-md-8">
              <multiselect
                v-model="departmentGeneral"
                tag-placeholder="Add this as new tag"
                placeholder="Departman seçiniz"
                label=""
                track-by=""
                :options="departmentsData"
                :searchable="true"
                :multiple="true"
                :max="1"
                style="padding: 0"
                selectLabel="Seçmek için tıklayınız"
                selectedLabel="Seçildi"
                deselectLabel="Silmek için tıklayınız"
              >
              </multiselect>
            </div>
          </div>
          <div class="col-12 col-md-6 column-flex">
            <div class="col-md-4">
              <label>Departman</label>
            </div>
            <div class="col-md-8">
              <multiselect
                v-model="department"
                tag-placeholder="Add this as new tag"
                placeholder="Departman seçiniz"
                label="Name"
                track-by="Id"
                :options="filteredDepartmentData"
                :searchable="true"
                :multiple="true"
                :max="1"
                style="padding: 0"
                selectLabel="Seçmek için tıklayınız"
                selectedLabel="Seçildi"
                deselectLabel="Silmek için tıklayınız"
                :internal-search="false"
                @search-change="asyncFindDepartment"
              >
              </multiselect>
            </div>
          </div>
          <div class="col-12 col-md-6 column-flex">
            <div class="col-md-4">
              <label>Bölüm</label>
            </div>
            <div class="col-md-8">
              <multiselect
                v-model="section"
                tag-placeholder="Add this as new tag"
                placeholder="Bölüm seçiniz"
                label="Name"
                track-by="Id"
                :options="filteredSectionData"
                :searchable="true"
                :multiple="true"
                :max="1"
                style="padding: 0"
                selectLabel="Seçmek için tıklayınız"
                selectedLabel="Seçildi"
                deselectLabel="Silmek için tıklayınız"
                :internal-search="false"
                @search-change="asyncFindSection"
              >
              </multiselect>
            </div>
          </div>
          <div class="col-12 col-md-6 column-flex">
            <div class="col-md-4">
              <label>Birim</label>
            </div>
            <div class="col-md-8">
              <multiselect
                v-model="unit"
                tag-placeholder="Add this as new tag"
                placeholder="Birim seçiniz"
                label="Name"
                track-by="Id"
                :options="filteredUnitData"
                :searchable="true"
                :multiple="true"
                :max="1"
                style="padding: 0"
                selectLabel="Seçmek için tıklayınız"
                selectedLabel="Seçildi"
                deselectLabel="Silmek için tıklayınız"
                :internal-search="false"
                @search-change="asyncFindUnit"
              >
              </multiselect>
            </div>
          </div>
          <div
            v-if="isForm == 'product' || isForm == 'projectPool'"
            class="col-12 col-md-6 column-flex mb-3"
          >
            <div class="col-md-4">
              <label for="title">Proje Adı</label>
            </div>
            <div class="col-md-8">
              <input
                type="text"
                class="form-control"
                id="title"
                name="title"
                v-model="title"
              />
            </div>
          </div>
          <div
            v-if="isForm == 'product' || isForm == 'projectPool'"
            class="col-12 col-md-6 column-flex"
          >
            <div class="col-md-4">
              <label for="txtProjectName">Proje Yılı</label>
            </div>
            <div class="col-md-8">
              <select
                class="form-control"
                data-val="true"
                data-val-number="The field Value must be a number."
                data-val-required="The Value field is required."
                id="drpProjectYear"
                name="ProjectYear.Value"
                v-model="projectYear"
              >
                <option
                  v-for="item in projectYearList"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.label }}
                </option>
              </select>
            </div>
          </div>
          <div
            v-if="
              isForm == 'product' || isForm == 'projectPool' || isForm == 'idea'
            "
            class="col-12 col-md-6 column-flex"
          >
            <div class="col-md-4">
              <label for="searchFilterStatus">Ekip Lideri</label>
            </div>
            <div class="col-md-8">
              <multiselect
                v-model="teamLeader"
                tag-placeholder="Add this as new tag"
                placeholder="Ekip Lideri"
                label="Name"
                track-by="Id"
                :options="filteredTeamLeaderData"
                :searchable="true"
                :multiple="true"
                :max="1"
                :loading="isLoadingUsers"
                style="padding: 0"
                selectLabel="Seçmek için tıklayınız"
                selectedLabel="Seçildi"
                deselectLabel="Silmek için tıklayınız"
                :internal-search="false"
                @search-change="asyncFindTeamLeader"
              >
              </multiselect>
            </div>
          </div>
          <div
            v-if="isForm == 'product' || isForm == 'projectPool'"
            class="col-12 col-md-6 column-flex"
          >
            <div class="col-md-4">
              <label for="searchFilterStatus">Değer Akım Yöneticisi</label>
            </div>
            <div class="col-md-8">
              <multiselect
                v-model="valueCurrentLeader"
                tag-placeholder="Add this as new tag"
                placeholder="Değer Akım Yöneticisi"
                label="Name"
                track-by="Id"
                :options="filteredValuelistLeaderData"
                :searchable="true"
                :multiple="true"
                :max="1"
                :loading="isLoadingUsers"
                style="padding: 0"
                selectLabel="Seçmek için tıklayınız"
                selectedLabel="Seçildi"
                deselectLabel="Silmek için tıklayınız"
                :internal-search="false"
                @search-change="asyncFindValuelistLeader"
              >
              </multiselect>
            </div>
          </div>
          <div v-if="isForm == 'idea'" class="col-12 col-md-6 column-flex">
            <div class="col-md-4">
              <label for="searchFilterStatus">Değerlendirici</label>
            </div>
            <div class="col-md-8">
              <multiselect
                v-model="selectEvaluator"
                tag-placeholder="Add this as new tag"
                placeholder="Değerlendirici"
                label="Name"
                track-by="Id"
                :options="filteredEvaluatorData"
                :searchable="true"
                :multiple="true"
                :max="1"
                :loading="isLoadingUsers"
                style="padding: 0"
                selectLabel="Seçmek için tıklayınız"
                selectedLabel="Seçildi"
                deselectLabel="Silmek için tıklayınız"
                :internal-search="false"
                @search-change="asyncFindEvaluator"
              >
              </multiselect>
            </div>
          </div>
          <div v-if="isForm == 'idea'" class="col-12 col-md-6 column-flex">
            <div class="col-md-4">
              <label for="searchFilterStatus">Karar Verici</label>
            </div>
            <div class="col-md-8">
              <multiselect
                v-model="selectDecider"
                tag-placeholder="Add this as new tag"
                placeholder="Karar verici"
                label="Name"
                track-by="Id"
                :options="filteredDeciderData"
                :searchable="true"
                :multiple="true"
                :max="1"
                :loading="isLoadingUsers"
                style="padding: 0"
                selectLabel="Seçmek için tıklayınız"
                selectedLabel="Seçildi"
                deselectLabel="Silmek için tıklayınız"
                :internal-search="false"
                @search-change="asyncFindDecider"
              >
              </multiselect>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer w-100 border-0 justify-content-end">
        <button
          v-if="isControlBtn && isControlBtn == 'MyAssignments'"
          @click.stop="continuityTrackingList"
          type="button"
          class="btn-innovation-modal bg-primary lh-normal"
        >
          Süreklilik Takibi
        </button>
        <button
          @click="searchFilterRemoveValue"
          type="reset"
          class="btn-innovation-modal bg-orange"
        >
          Sıfırla
        </button>
        <button
          @click="searchFilter"
          type="button"
          class="btn-innovation-modal bg-orange"
        >
          Filtrele <span class="icon-arrow-right pl-2"></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { yearList, customSearchTextFormatter } from "../../helpers";
import Multiselect from "vue-multiselect";
import "../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css";
export default {
  name: "SearchForm",
  data() {
    return {
      isLoadingUsers: false,
      optionUsers: [],
      statusOptions: [],
      currenValuelist: [],
      selectedCompany: "",
      suggestionNumber: "",
      valueCurrentId: "",
      suggestionStatuses: [],
      createdUserId: null,
      searchKeyword: "",
      startDate: null,
      endDate: null,
      teamLeader: null,
      optionTeamLeader: [],
      valueCurrentLeader: null,
      currenValuelistLeader: [],
      title: "",
      projectYear: null,
      projectYearList: [],
      selectDecider: null,
      deciderList: [],
      evaluatorList: [],
      selectEvaluator: null,
      department: "",
      section: "",
      unit: "",
      departmentGeneral: "",
      companiesList: [],
      filteredData: [],
      filteredTeamLeaderData: [],
      filteredValuelistLeaderData: [],
      filteredDeciderData: [],
      filteredEvaluatorData: [],
      filteredDepartmentData: [],
      filteredSectionData: [],
      filteredUnitData: [],
      filteredStatusData: [],
      departmentList: [],
      sectionList: [],
      unitList: [],
      statusList: [],
      searchFilterText: "",
    };
  },
  props: {
    location: {
      type: String,
      default: "evaluation-invendo",
    },
    searchText: {
      type: String,
    },
    isIdea: {
      type: String,
    },
    isLayout: {
      type: String,
    },
    isForm: {
      type: String,
    },
    isControlBtn: {
      type: String,
    },
    suggestionTypeId: {
      type: String,
    },
  },
  components: {
    Multiselect,
  },
  computed: {
    ...mapGetters({
      user: "user/user",
    }),
    getUsers() {
      return this.$store.getters["user/getUsers"];
    },
    getCompanies() {
      return this.$store.getters["suggestion/companiesData"];
    },
    gettersValueCurrents() {
      return this.$store.getters["suggestion/getValueCurrents"];
    },
    departmentsData() {
      return this.$store.getters["suggestionRD/departmentsData"];
    },
    sectionsData() {
      return this.$store.getters["suggestionRD/sectionsData"];
    },
    unitsData() {
      return this.$store.getters["suggestionRD/unitsData"];
    },
    gettersStatusByRoles() {
      return this.$store.getters["suggestion/statusByRoles"];
    },
    statusByRolesInvendo() {
      return this.$store.getters["suggestion/statusByRolesInvendo"];
    },
    statusByRolesProductization() {
      return this.$store.getters["suggestion/statusByRolesProductization"];
    },
  },
  watch: {
    getUsers: {
      handler: function (val) {
        // Return the object that changed
        val.forEach((element) => {
          this.setUsers(element);
        });
        this.filteredData = this.optionUsers;
        this.filteredTeamLeaderData = this.optionTeamLeader;
        this.filteredValuelistLeaderData = this.currenValuelistLeader;
        this.filteredDeciderData = this.deciderList;
        this.filteredEvaluatorData = this.evaluatorList;
        this.isLoadingUsers = false;
        this.selectedUser();
      },
      deep: true,
    },
  },
  async created() {
    this.projectYearList = yearList();
    if (this.isForm == "product") {
      await this.$store.dispatch("suggestionRD/getDepartments", true);
      await this.$store.dispatch("suggestionRD/getSections", true);
      await this.$store.dispatch("suggestionRD/getUnits", true);
    }
    if (this.isForm == "idea") {
      await this.$store.dispatch("suggestionRD/getDepartments", false);
      await this.$store.dispatch("suggestionRD/getSections", false);
      await this.$store.dispatch("suggestionRD/getUnits", false);
    }

    this.isLoadingUsers = true;
    if (!this.getUsers) {
      await this.$store.dispatch("user/getUsers");
      // isLoadingUsers will be set to false in the watcher when data arrives
    } else {
      this.getUsers.forEach((element) => {
        this.setUsers(element);
      });
      this.isLoadingUsers = false;
    }
    this.departmentsData.forEach((element) => {
      this.setDepartment(element);
    });
    this.sectionsData.forEach((element) => {
      this.setSection(element);
    });
    this.unitsData.forEach((element) => {
      this.setUnit(element);
    });
    this.setFilteredData();
    if (this.searchText != "") {
      this.searchKeyword = this.searchText;
      this.searchFilter();
    }
    await this.getValueCurrents();
    await this.getStatusByRoles();
    this.statusOptions.forEach((element) => {
      this.setStatus(element);
    });
    if (!this.getCompanies) await this.$store.dispatch("suggestion/setData");
    this.companiesList = [{ Id: "", Name: "Tümü" }, ...this.getCompanies];
    this.selectedUser();
    this.equalData();
  },
  methods: {
    asyncFind(query) {
      this.searchFilterText = query;
      this.filteredData = this.optionUsers.filter(this.customSearch);
    },
    asyncFindTeamLeader(query) {
      this.searchFilterText = query;
      this.filteredTeamLeaderData = this.optionTeamLeader.filter(
        this.customSearch
      );
    },
    asyncFindValuelistLeader(query) {
      this.searchFilterText = query;
      this.filteredValuelistLeaderData = this.currenValuelistLeader.filter(
        this.customSearch
      );
    },
    asyncFindDecider(query) {
      this.searchFilterText = query;
      this.filteredDeciderData = this.deciderList.filter(this.customSearch);
    },
    asyncFindEvaluator(query) {
      this.searchFilterText = query;
      this.filteredEvaluatorData = this.evaluatorList.filter(this.customSearch);
    },
    asyncFindDepartment(query) {
      this.searchFilterText = query;
      this.filteredDepartmentData = this.departmentList.filter(
        this.customSearch
      );
    },
    asyncFindSection(query) {
      this.searchFilterText = query;
      this.filteredSectionData = this.sectionList.filter(this.customSearch);
    },
    asyncFindUnit(query) {
      this.searchFilterText = query;
      this.filteredUnitData = this.unitList.filter(this.customSearch);
    },
    asyncFindStatus(query) {
      this.searchFilterText = query;
      this.filteredStatusData = this.statusList.filter(this.customSearch);
    },
    customSearch(event) {
      return customSearchTextFormatter(event.name ?? event.Name).includes(
        customSearchTextFormatter(this.searchFilterText)
      );
    },
    equateSelectedCompany() {
      if (
        this.getCompanies.length == 2 &&
        this.getCompanies[0].Id == 2 &&
        this.getCompanies[1].Id == 7
      ) {
        this.selectedCompany = "";
      } else {
        this.selectedCompany = this.user.Data.CompanyId;
      }
    },
    equalData() {
      this.equateSelectedCompany();
    },
    async getStatusByRoles() {
      if (this.suggestionTypeId == "1") {
        if (this.gettersStatusByRoles.length == 0) {
          await this.$store.dispatch("suggestion/getStatusByRoles", {
            suggestionTypeId: this.suggestionTypeId,
            companyId: this.user.Data.CompanyId,
          });
        }
        for await (const element of this.gettersStatusByRoles) {
          this.statusOptions.push({
            code: element.StatusId,
            name: element.StatusName,
          });
        }
      } else if (this.suggestionTypeId == "3") {
        if (this.statusByRolesProductization.length == 0) {
          await this.$store.dispatch(
            "suggestion/getStatusByRolesProductization",
            {
              suggestionTypeId: this.suggestionTypeId,
              companyId: this.user.Data.CompanyId,
            }
          );
        }
        for await (const element of this.statusByRolesProductization) {
          this.statusOptions.push({
            code: element.StatusId,
            name: element.StatusName,
          });
        }
      } else if (this.suggestionTypeId == "4") {
        if (this.statusByRolesInvendo.length == 0) {
          await this.$store.dispatch("suggestion/getStatusByRolesInvendo", {
            suggestionTypeId: this.suggestionTypeId,
            companyId: this.user.Data.CompanyId,
          });
        }
        for await (const element of this.statusByRolesProductization) {
          this.statusOptions.push({
            code: element.StatusId,
            name: element.StatusName,
          });
        }
      }
    },
    setFilteredData() {
      this.filteredData = this.optionUsers;
      this.filteredTeamLeaderData = this.optionTeamLeader;
      this.filteredValuelistLeaderData = this.currenValuelistLeader;
      this.filteredDeciderData = this.deciderList;
      this.filteredEvaluatorData = this.evaluatorList;
      this.filteredDepartmentData = this.departmentList;
      this.filteredSectionData = this.sectionList;
      this.filteredUnitData = this.unitList;
      this.filteredStatusData = this.statusList;
    },
    setDepartment(element) {
      this.departmentList.push({
        Name: element,
        Id: element,
      });
    },
    setSection(element) {
      this.sectionList.push({
        Name: element,
        Id: element,
      });
    },
    setUnit(element) {
      this.unitList.push({
        Name: element,
        Id: element,
      });
    },
    setStatus(element) {
      this.statusList.push({
        name: element.name,
        code: element.code,
      });
    },
    setUsers(element) {
      this.optionUsers.push({
        name: element.FullName + " (" + element.CompanyName + ")",
        code: element.Id,
      });
      this.optionTeamLeader.push({
        Name: element.FullName + " (" + element.CompanyName + ")",
        Id: element.Id,
      });
      this.currenValuelistLeader.push({
        Name: element.FullName + " (" + element.CompanyName + ")",
        Id: element.Id,
      });
      this.deciderList.push({
        Name: element.FullName + " (" + element.CompanyName + ")",
        Id: element.Id,
      });
      this.evaluatorList.push({
        Name: element.FullName + " (" + element.CompanyName + ")",
        Id: element.Id,
      });
    },
    selectedUser() {
      if (this.isIdea == "my-idea" && this.isForm != "projectPool") {
        this.createdUserId = this.optionUsers.filter(
          (u) => u.code == this.user.Data.UserId
        );
      } else {
        this.createdUserId = null;
      }
    },
    async valueCurrentsFill() {
      if (this.gettersValueCurrents.length > 0) {
        this.currenValuelist = this.gettersValueCurrents;
      }
    },
    async getValueCurrents() {
      if (this.gettersValueCurrents.length == 0) {
        await this.$store.dispatch("suggestion/getValueCurrentsData");
      }
      await this.valueCurrentsFill();
    },
    searchFilterRemoveValue() {
      this.equateSelectedCompany();
      this.suggestionNumber = "";
      this.valueCurrentId = "";
      this.suggestionStatuses = [];
      this.createdUserId = null;
      this.searchKeyword = "";
      this.startDate = null;
      this.endDate = null;
      this.selectEvaluator = null;
      this.department = "";
      this.section = "";
      (this.unit = ""), (this.departmentGeneral = "");
      this.selectDecider = null;
      this.title = null;
      this.projectYear = null;
      this.teamLeader = null;
      this.valueCurrentLeader = null;
      const data = {
        suggestionNumber: this.suggestionNumber,
        companyId: this.selectedCompany,
        valueCurrentId: this.valueCurrentId,
        suggestionStatuses: this.suggestionStatuses,
        searchKeyword: this.searchKeyword,
        startDate: this.startDate,
        endDate: this.endDate,
        suggestionEvaluatorId: this.selectEvaluator,
        suggestionDeciderId: this.selectDecider,
        department: this.department,
        section: this.section,
        unit: this.unit,
        valueCurrentManagerId: this.valueCurrentLeader,
        teamLeaderId: this.teamLeader,
        title: this.title,
        projectYear: this.projectYear,
      };
      this.$emit("clear-search-filter", data);
    },
    searchFilter() {
      let _tmpSuggestionStatusesId = [];
      let data = null;
      this.suggestionStatuses.map((i) => _tmpSuggestionStatusesId.push(i.code));
      const createdUserId = this.createdUserId
        ? this.createdUserId[0]?.code
        : null;
      data = {
        suggestionNumber: this.suggestionNumber,
        companyId: this.selectedCompany,
        valueCurrentId: this.valueCurrentId,
        suggestionStatuses: _tmpSuggestionStatusesId,
        searchKeyword: this.searchKeyword,
        startDate: this.startDate,
        endDate: this.endDate,
        suggestionEvaluatorId: this.selectEvaluator
          ? this.selectEvaluator[0]?.Id
          : null,
        suggestionDeciderId: this.selectDecider
          ? this.selectDecider[0]?.Id
          : null,
        department: this.department ? this.department[0]?.Name : null,
        section: this.section ? this.section[0]?.Name : null,
        unit: this.unit ? this.unit[0]?.Name : null,
        departmentGeneral: this.departmentGeneral
          ? this.departmentGeneral[0]
          : null,
        valueCurrentManagerId: this.valueCurrentLeader
          ? this.valueCurrentLeader[0]?.Id
          : null,
        title: this.title,
        projectYear: this.projectYear,
        teamLeaderId: this.teamLeader ? this.teamLeader[0]?.Id : null,
      };
      this.isForm == "idea"
        ? (data.suggestionTeamLeaderId = this.teamLeader?.Id
            ? this.teamLeader?.Id
            : null)
        : this.isForm == "product"
        ? (data.teamLeaderId = this.teamLeader ? this.teamLeader[0]?.Id : null)
        : "";
      if (this.isIdea != "my-idea") data.createdUserId = createdUserId;

      this.$store.dispatch("ideas/setFilterIdea", data);
      this.$emit("search-filter", data);
    },
    continuityTrackingList() {
      this.$emit("continuity-tracking-list");
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.options.push(tag);
      this.suggestionStatuses.push(tag);
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/admin/styles/scss/idea-form.scss";

.multiselect__spinner {
  right: 50% !important;
  transform: translateX(50%);
}
</style>
